import TkInfoManual from "../../components/atoms/TkInfoManual";
import { stepperData, tableHeadList } from "./parts";
import "./_style.scss";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkStrpper from "../../components/atoms/TkStepper";
import TkButton from "../../components/atoms/TkButton";
import { httpAPI_FAC014, httpAPI_FAC030, httpAPI_FAC031 } from "./api/request";
import {
  IAPI_FAC014_Request,
  IAPI_FAC030_Request,
  IAPI_FAC031_Response,
} from "../../type/apiType";
import { ISampleTableData } from "../../type/componentsType/TkFacilityTableChanger";
import { Box, Typography } from "@mui/material";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFacilityTableChanger from "../../components/molecules/TkFacilityTableChanger";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { FacilityKind } from "../../assets/data/Constants";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { FacilityList } from "../../type/apiType/IAPI_FAC031";
import { toNumberOrUndefined } from "../../utils/useTools";

/**
 * SCRC050102コンポーネント。
 * このコンポーネントは、TkInfoManual,TkMessageDialog,TkFacilityTableChangerをレンダリングします。
 * @returns JSX.Element SCRC050102 新規契約情報入力（施設情報）一覧
 */
const SCRC050102 = () => {
  const navigate = useNavigate();
  //初期表示API取得結果
  const [apiGetData, setApiGetData] = useState<IAPI_FAC031_Response>({});
  //削除用APIリクエスト
  const [httpDeleteReq, setDeleteHttpReq] = useState<IAPI_FAC014_Request>({});
  //テーブルのBody
  const [bodyList, setBodyList] = useState<ISampleTableData[] | undefined>([]);
  const [aBodyList, setABodyList] = useState<any>();
  //一時保存ダイヤログ
  const [openSuccess, setOpenSuccess] = useState(false);
  //削除ダイヤログ
  const [openSuccessDelete, setOpenSuccessDelete] = useState(false);
  //業務用Contextを更新するState
  const { state: businessState, setState: setBusinessStete } =
    useContext(BusinessContext);
  //グローバルContextを更新するState
  const { state, setState } = useContext(GlobalContext);

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //初期表示時にAPI取得結果をもとに、TkFacilityTableChangerのテーブルの中身をsetする。
  useEffect(() => {
    let bodyinput: ISampleTableData[] | undefined =
      apiGetData?.facilityList?.map((item: any) => {
        let facilityList: ISampleTableData = {
          id: item.facilityNo,
          No: item.facilityNo,
          FName: item.facilityName,
          FType: FacilityKind[item.facilityKind as keyof typeof FacilityKind],
          allApplicationPerson: item.totalStaffNum,
          joinStaffNum: item.joinStaffNum,
          yearJoindisableStaffNum: item.yearJoindisableStaffNum,
          timeJoindisableStaffNum: item.timeJoindisableStaffNum,
          staffRegistrationStatus: item.staffRegistrationStatus,
          facilityInfoModify: (
            <Box className="SCRC050102FixAndDeleteButton">
              <TkButton
                data-testid="fixButton"
                onClick={() => handleFix(item.facilityNo)}
              >
                修正
              </TkButton>
              <TkButton
                data-testid="deleteButton"
                onClick={() => onCheckAndSubmitDelete(item.facilityNo)}
              >
                削除
              </TkButton>
            </Box>
          ),
          stuffInfoRegistration: (
            <Box className="SCRC050102StuffInfoResister">
              <TkButton
                data-testid="StuffInfoResister"
                onClick={() => handleStuffInfoResister(item)}
              >
                職員情報登録
              </TkButton>
            </Box>
          ),
        };
        return facilityList;
      });

    setBodyList(bodyinput);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiGetData]);

  const handleInit = async () => {
    // 申請施設一覧参照API 呼び出し
    try {
      const res: IAPI_FAC031_Response = await httpAPI_FAC031({
        applyId: businessState.job_01?.applyId,
      });

      if (res.resultCd === "I0000") {
        setApiGetData(res);

        setBusinessStete({
          ...businessState,
          job_01: {
            ...businessState.job_01,
            applyId: res.applyId,
            facilityNo: "",
            facilityName: "",
            facilityKind: "",
          },
        });

        setState({ ...state, errorMsgId: "" });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //修正ボタン用イベント
  const handleFix = (FacilityNo: any) => {
    setBusinessStete({
      ...businessState,
      job_01: {
        ...businessState.job_01,
        facilityNo: FacilityNo,
      },
    });
    navigate("/SCRC050101");
  };

  //施設追加ボタン用イベント
  const handleEdit = () => {
    navigate("/SCRC050101");
  };

  //職員情報登録ボタン用イベント
  const handleStuffInfoResister = (item: FacilityList) => {
    //加入止めフラグと部分解除フラグは現状最新のAPIでは帰ってこないため持回情報には設定していない状態
    setBusinessStete({
      ...businessState,
      job_01: {
        ...businessState.job_01,
        facilityNo: item.facilityNo,
        facilityName: item.facilityName,
        facilityKind: item.facilityKind,
        noJoinFlg: item.noJoinFlg,
        partialReleaseFlg: item.partialReleaseFlg,
      },
    });

    navigate("/SCRC060106");
  };

  // 一時保存
  const onCheckAndSubmit = async () => {
    // 施設表示順更新（申請施設）API 呼び出し
    try {
      const res = await httpAPI_FAC030({
        ...makeHttpObj(),
      });

      if (res.resultCd === "I0000") {
        setOpenSuccess(true);

        setBusinessStete({
          ...businessState,
          job_01: {
            ...businessState.job_01,
            tempSaveStep: 2,
          },
        });

        setState({ ...state, errorMsgId: "" });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  // 削除
  const onCheckAndSubmitDelete = (FacilityNo: string) => {
    setDeleteHttpReq({ ...makeHttpDeleteObj(FacilityNo) });

    setOpenSuccessDelete(true);
  };

  const handleOKDelete = async () => {
    // 施設情報削除API 呼び出し
    try {
      const res = await httpAPI_FAC014({
        ...httpDeleteReq,
      });

      if (res.resultCd === "I0000") {
        setOpenSuccessDelete(false);
        handleInit();

        setState({ ...state, errorMsgId: "" });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //登録完了ボタン押下時に更新用APIを呼び出すイベント
  const onHandleUpdateAPI = async () => {
    try {
      const res = await httpAPI_FAC030({
        ...makeHttpObj(),
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRC060007");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //テーブル行移動並べ替えイベント:
  const changeFacilityNumberModify = (res: any[] | undefined) => {
    let facilityList = res?.map((item) => {
      return {
        facilityNo: item[0]?.id,
        totalStaffNum: toNumberOrUndefined(item[4]?.children?.replace(",", "")),
        joinStaffNum: toNumberOrUndefined(item[5]?.children?.replace(",", "")),
      };
    });

    setABodyList(facilityList);
  };

  /**
   * 更新API用リクエストを作成
   * @param obj リクエスト作成に必要なデータ
   */
  const makeHttpObj = (): IAPI_FAC030_Request => {
    let list = aBodyList ?? apiGetData.facilityList;

    let facilityList = list?.map((item: any, index: any) => {
      return {
        facilityNo: item.facilityNo,
        facilityDispOrder: index + 1,
        totalStaffNum: item.totalStaffNum,
        joinStaffNum: item.joinStaffNum,
      };
    });

    const reqObj: IAPI_FAC030_Request = {
      applyId: businessState.job_01?.applyId ? businessState.job_01.applyId : 0,
      facilityList: facilityList,
    };

    return reqObj;
  };

  /**
   * 削除API用リクエストを作成
   * @param obj リクエスト作成に必要なデータ
   */
  const makeHttpDeleteObj = (FacilityNo: string): IAPI_FAC014_Request => {
    const reqObj: IAPI_FAC014_Request = {
      applyId: businessState.job_01?.applyId,
      facilityNo: FacilityNo,
    };

    return reqObj;
  };

  return (
    <Box data-testid="SCRC050102PageForTest" className="SCRC050102View">
      <TkStrpper
        steps={stepperData}
        activeStep={1}
        savaStep={businessState.job_01?.tempSaveStep}
      />

      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050102_01}</TkInfoManual>

      {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState.common?.contractorNo +
            ":" +
            businessState.common?.contractorName
          }
        />
      )}

      <Box className="SCRC050102facilityEdit">
        <TkButton onClick={() => handleEdit()}>施設追加</TkButton>
      </Box>

      <TkFacilityTableChanger
        facilityList={bodyList}
        headList={tableHeadList}
        onClick={changeFacilityNumberModify}
      />

      <Box className="SCRC050102LabelTextRegisterSuccess">
        <Typography>
          すべての施設の職員登録が完了したら、「登録完了」ボタンを押下してください。
        </Typography>
      </Box>

      <Box className="SCRC050102twoButton">
        <TkBackButton />
        <TkButton data-testid="checkAndSubmit" onClick={onCheckAndSubmit}>
          一時保存
        </TkButton>
        <TkButton
          disabled={
            !apiGetData?.facilityList || apiGetData?.facilityList?.length === 0
          }
          data-testid="registerSuccess"
          onClick={onHandleUpdateAPI}
        >
          登録完了
        </TkButton>
      </Box>

      <TkMessageDialog
        open={openSuccess}
        onOky={() => setOpenSuccess(false)}
        title="一時保存完了"
        contextText="　一時保存が完了しました。"
        okText="はい"
        cancelText=""
      />

      <TkMessageDialog
        open={openSuccessDelete}
        onOky={handleOKDelete}
        onCancel={() => setOpenSuccessDelete(false)}
        title="確認（施設情報を削除します）"
        contextText="　施設情報の削除を行いますが、問題ないでしょうか（選択された施設に紐付いた職員情報も削除されます）。"
        cancelText="いいえ"
        okText="はい"
      />
    </Box>
  );
};

export default SCRC050102;
